import { Component, HostBinding, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { AppState } from '../app.types';
import { CountdownWrapperComponent } from '../cms/common/countdown-wrapper/countdown-wrapper.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'qa-poll-announcement',
  template: `
    <qa-countdown-wrapper [isPollQuestion]="true"> </qa-countdown-wrapper>
  `,
  styleUrls: ['poll-announcement.component.scss'],
  imports: [CountdownWrapperComponent, TranslateModule],
})
export class PollAnnouncementComponent implements OnInit {
  @HostBinding('class.disabled')
  done = false;
  state: AppState;

  constructor(store: Store<AppState>) {
    store.pipe(take(1)).subscribe((state) => {
      this.state = state;
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.done = true;
    }, 3500);
  }
}
